import { actions } from "./types";

export function setCurrentUser(objects) {
  return (dispatch) => {
    dispatch({
      type: actions.SET_CURRENTUSER,
      payload: objects,
    });
  };
}
